export enum Languages {
    EN = 'en',
    FR = 'fr',
    DE = 'de',
    ES = 'es',
}
